import type { QuoteState, SmartSendItemApiModel } from '~/lib/api/smartsend/types';

/**
 * Pure accessors for the service tags a quote carries. Deliberately a leaf module - these used to
 * live in SmartSendSummaryGenerator, which reaches into the item component tree, so anything
 * needing only a tag pulled half the app in behind it and closed an import cycle.
 */
export const GetQuoteServiceTagsFromItem = (item: SmartSendItemApiModel): string[] =>
  item?.State?.validation?.QuoteState?.Quote?.Service?.Tags || [];

export const GetQuoteServiceTags = (x: QuoteState): string[] => x?.Quote?.Service?.Tags || [];

export const GetItemServiceTags = (x: SmartSendItemApiModel): string[] =>
  GetQuoteServiceTags(x.State?.validation?.QuoteState);
